(function() {
    'use strict'

    var pluginName = "scroller";
    var defaults = {

    };

    // Plugin constructor
    function Plugin(element, options) {
        this.element = element;
        this.options = $.extend({}, defaults, options);
        this._defaults = defaults;
        this._name = pluginName;

        this.init();
    }

    // Plugin Methods
    Plugin.prototype = {
        init: function() {
            this.$element = $(this.element);
            this.$sections = $('.js-section');
            this.$menu = $('.js-menu');
            this.$menuItems = $('.js-menu-item');
            this.defaultTemplate = $('body').hasClass('default');
            this.Pos = 0;
            this.lastPos = 0;
            this.didScroll = false;

            this.checkDesktopInit();
            this.bindEvents();
        },

        checkDesktopInit() {
          if (window.matchMedia) {
            if (window.matchMedia('only screen and (min-width: 900px)').matches) {
              $('.js-header').removeClass('is-hidden');
            }
          }
        },

        checkDesktop(diff) {
          if (diff > 20 && this.Pos > window.innerHeight) {
            this.lastPos = this.Pos;
            $('.js-header').addClass('is-hidden');
          }
        },

        checkMobile(diff) {
          if (diff > 20 || ($('body').is('.default, .legaltext') && this.Pos < window.headerHeight)) {
            this.lastPos = this.Pos;
            $('.js-header').addClass('is-hidden');
          }
        },

        tick() {
            this.setHeader();
            if (this.defaultTemplate) {
                this.setActiveMenuItem();
            }
        },

        setHeader() {
          this.Pos = window.pageYOffset;
          const diff = this.Pos - this.lastPos;

          if (diff < -20 && this.Pos > window.innerHeight / 2) {
            this.lastPos = this.Pos;
            $('.js-header').removeClass('is-hidden');
          }

          else if (window.matchMedia) {
            if (window.matchMedia('only screen and (min-width: 900px)').matches) {
              this.checkDesktop(diff);
            }
            else {
              this.checkMobile(diff);
            }
          }
        },

        setActiveMenuItem() {
            $(this.$sections.get().reverse()).each(function(index, item) {
                if ($(item).get(0).getBoundingClientRect().top < 50) {
                    $('.is-active.js-menu-item').removeClass('is-active');
                    $('[data-to="' + $(item).attr('id') + '"]', this.$menu).addClass('is-active');

                    return false;
                }
            });
        },

        scroll(e) {
            if (window.requestAnimationFrame) {

                if (!this.didScroll) {
                    this.didScroll = true;

                    window.requestAnimationFrame(this.tick.bind(this));
                }

                window.setTimeout(function() {
                    this.didScroll = false;
                }.bind(this), 100);
            }
        },

        // EVENTS
        bindEvents() {
            this.$element.on('scroll', this.scroll.bind(this));
        }
    };

    // Plugin wrapper
    $.fn[pluginName] = function(options) {
        return this.each(function() {
            if(!$.data(this, "plugin_" + pluginName)) {
                $.data(this, "plugin_" + pluginName, new Plugin(this, options));
            }
        });
    }
}());
